import { api } from '@services';

interface ICreateTicket {
  title: string;
  description: string;
  type: string;
  status: string;
  equipmentId: string;
}

const createTicket = async (data: ICreateTicket): Promise<void> => {
  await api.post('/tickets', data);
};

export { createTicket };
